import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AuthContext } from './context/AuthContext';
import { NotificationContainer } from './components/Notifier';

ReactDOM.render(
  <NotificationContainer>
    <AuthContext>
      <App />
    </AuthContext>
  </NotificationContainer>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
